<section [formGroup]="personal_info">

  <mat-form-field>
    <app-date-picker matInput formControlName="birthday" placeholder="Date of Birth"
                     [max]="maxDate" [min]="minDate" touchUi="true" required></app-date-picker>
    <mat-error *ngIf="personal_info.get('birthday').hasError('required')">Required.</mat-error>
  </mat-form-field>
</section>
